import React from "react";

const CustomerModalSubtitle = ({ customerName }) => {
  if (!customerName) return null;

  return <div style={{ marginBottom: 12, color: "#666", fontWeight: 600 }}>{customerName}</div>;
};

export default CustomerModalSubtitle;
